import Swiper from 'swiper';
import {A11y, Navigation, Keyboard, Scrollbar} from 'swiper/modules';
import imagesLoaded from 'imagesloaded';

const imageSliders = document.querySelectorAll('.image-slider');

for (const slider of imageSliders) {
	imagesLoaded(slider, function() {
		const imageSlider = new Swiper(
			slider.querySelector('.image-slider__images-slider'),
			{
				modules: [
					A11y,
					Navigation,
					Keyboard,
					Scrollbar,
				],
				spaceBetween: 32,
				grabCursor: true,
				slidesPerView: 1,
				a11y: {
					prevSlideMessage: window.wkScriptVars.previous_slide,
					nextSlideMessage: window.wkScriptVars.next_slide,
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				navigation: {
					prevEl: slider.querySelector('.slider-navigation__button--prev'),
					nextEl: slider.querySelector('.slider-navigation__button--next'),
				},
				scrollbar: {
					el: slider.querySelector('.swiper-scrollbar'),
				},
			},
		);
	});
}
